import styled from 'styled-components';

export const FooterBlockMainWrap = styled.footer(
  props => `
        width:100%;
        display: flex;
        margin: 4rem 0 0 0;
        position:relative;
        flex-direction: column;
        @media(max-width:1023px){
            padding:0;
            margin:0;
        }
    `,
);

export const FooterOuterWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        background-color: #f2ecf3;
        padding: 3rem 0;
        border-radius: 10rem 10rem 0 0;
        @media only screen and (min-width:1024px) and (max-width:1350px){
            padding: 2rem 2rem;
        }
    `,
);

export const FooterBlockInnerWrap = styled.div(
  props => `
        max-width:1310px;
        margin:0 auto;
        display: flex;
        width:100%;
        justify-content: space-between;
        flex-direction: column;
    `,
);

export const CopyrightTagWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top:5rem;
    `,
);

export const CopyrightTag = styled.p(
  props => `
        color:#3b415e;
        font-size: 1.2rem;
        text-transform: uppercase;
        font-weight:700;
    `,
);
